/**
 * Insurance Details Width
 */
export const INSURANC_EDETAILS_WIDTH = 240;

/**
 * Insurance Details Operator Width
 */
export const INSURANC_EDETAILS_OPERATOR_WIDTH = 72;

/**
 * Consultation tab enum
 */
export enum ConsultationTabKey {
  /**
   * consultation tab
   */
  Consultation = "consultation",
  /**
   * investigation tab
   */
  Investigation = "investigation",
  /**
   * invoice tab
   */
  Invoice = "invoice",
  /**
   * appointment tab
   */
  Appointment = "appointment",
  /**
   * documents tab
   */
  Documents = "documents",
  /**
   * dashboard tab
   */
  Dashboard = "dashboard",
  /**
   * dispensing tab
   */
  Dispensing = "dispensing",
  /**
   * charting tab
   */
  // Charting = "charting",
  /**
   * journal tab
   */
  Journal = "journal",
  /**
   * Deposit tab: the patient's credit balance history
   */
  Deposit = "deposit",
}

/**
 * Tab Permission Configuration
 * Maps each tab to its required permission
 * If permission is null, the tab is visible to all roles
 *
 * Note: All tabs are now visible to all roles (set to null)
 * Permissions are enforced within each tab's content based on user actions
 */
export const TAB_PERMISSIONS: Record<ConsultationTabKey, string | null> = {
  [ConsultationTabKey.Dashboard]: null, // Visible to all roles
  [ConsultationTabKey.Consultation]: null, // Visible to all roles (edit permissions controlled inside)
  [ConsultationTabKey.Dispensing]: null, // Visible to all roles (edit permissions controlled inside)
  [ConsultationTabKey.Invoice]: null, // Visible to all roles
  [ConsultationTabKey.Appointment]: null, // Visible to all roles
  [ConsultationTabKey.Investigation]: null, // Visible to all roles
  [ConsultationTabKey.Documents]: null, // Visible to all roles
  [ConsultationTabKey.Journal]: null, // Visible to all roles
  [ConsultationTabKey.Deposit]: null, // Visible to all roles (adding a deposit is gated inside)
};

export enum PatientEmitEum {
  EditAlerts = "edit-alerts",
  EditPatientInfo = "edit-patient-info",
  PrintPatientLabel = "print-patient-label",
  PrintMailingLabel = "print-mailing-label",
  PrintRadiologyDocuments = "print-radiology-documents",
  EditPatientAllergies = "edit-patient-allergies",
  ActivitiesLog = "activities-log",
}

export enum EditorType {
  /**
   * doctor note editor
   */
  ASSESSMENT_PLAN = "AssessmentPlan",
  /**
   * nursing note editor
   */
  NURSING_NOTE = "NursingNote",
}
